import { } from 'vue';
import BasePagedListFilterSetupService from '@/setup/BasePagedListFilterSetupService';
import { TIME_TICKET_WEEK_STEP } from '@/typings/enums/TIME_TICKET_WEEK_STEP';
import usetimeTicketYearPagedListFilterService from '@/services/time-ticket/TimeTicketYearPagedListFilterService';

type Props = SetupProps<typeof TimeTicketYearPagedListFilterSetupService.props>

export default class TimeTicketYearPagedListFilterSetupService
	extends BasePagedListFilterSetupService<Props, Armado.TimeTicketWeekPagedListParameters, Armado.TimeTicketWeekYear> {
	// static readonly props = {};

	protected filterService = usetimeTicketYearPagedListFilterService();

	readonly optionCurrentStep = [
		{
			label: `À saisir par l'intérimaire`,
			value: TIME_TICKET_WEEK_STEP.TempWorker,
		},
		{
			label: this.self.isAgency() ? 'À saisir par le client' : 'À saisir',
			value: TIME_TICKET_WEEK_STEP.Client,
		},
		{
			label: 'Validés',
			value: TIME_TICKET_WEEK_STEP.Agency,
		},
		{
			label: 'Intégrés',
			value: TIME_TICKET_WEEK_STEP.AgencyIntegrated,
		},
	];

	constructor (props?: Props, _aside?: OrionAside) {
		super(props, _aside);
	}
}
